import { th } from "../../../../date-fns/locale/th.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    th
  }
};